import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";

import { toast } from "react-toastify";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal } from "antd";
import QRCode from "qrcode.react";
import html2canvas from "html2canvas";
import Modal from "react-modal";

const PackagingLabelingListview = (props) => {
  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "60%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px",
      height: "80%",
      minHeight: "450px",
      overflow: "auto",
    },
  };

  const customModalStyles2 = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "450px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [boxQRData, setBoxQRData] = useState([]);

  const openModal = (data) => {
    //console.log(data);
    setSelectedData(data);
    //
    setIsModalOpen(true);
    const qrData =
      data.boxDetail &&
      data.boxDetail.map((item) => ({
        linesrno: item.linesrno,
        packedId: item.packedId,
        ispalltized: item.ispalltized,
        grossWeightId: item.grossWeightId,
        netWeightPerCarton: item.netWeightPerCarton,
        grossWeightPerCarton: item.grossWeightPerCarton,
        packagingProductName: data.packagingProductName,
        plmNo: data.plmNo,
        plmId: data.plmId,
      }));
    //console.log(qrData);

    generateQRData(qrData);
  };
  const generateQRData = (packDetails) => {
    // //console.log(packDetails);
    const qrData = packDetails.map((box) => ({
      // srNo: box.linesrno,
      // packedId: box.packedId,
      // grossWeightPerCarton: box.grossWeightPerCarton,
      // netWeightPerCarton: box.netWeightPerCarton,
      // productName: box.packagingProductName,
      // docNo: box.plmNo,
      Url: `${
        process.env.REACT_APP_LOCAL_URL
      }/packdetail/${localStorage.getItem("orgId")}/${box.plmId}`,
    }));
    setBoxQRData(qrData);
  };

  const { sendRequest: getpackagingLabelingMarking } = useHttp();

  const FillDetail = () => {
    getpackagingLabelingMarking(
      {
        url: "/api/packagingLabelingMarking/",
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, []);

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.plmNo.includes(filetrtext) ||
        item.employeeName.includes(filetrtext) ||
        item.packagingProductName.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const downloadQRCodeAtIndex = (index) => {
    const qrCodeContainers = document.querySelectorAll(".qr-con");

    if (index >= 0 && index < qrCodeContainers.length) {
      const selectedContainer = qrCodeContainers[index];

      html2canvas(selectedContainer).then((canvas) => {
        const imgURL = canvas.toDataURL("image/png");

        const downloadLink = document.createElement("a");
        downloadLink.href = imgURL;
        downloadLink.download = `box no ${index + 1}.png`;
        downloadLink.click();
      });
    }
  };

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [productDetails, setProductDetails] = useState([]);

  const viewOpen = (data) => {
    // //console.log(data);
    setSelected(data);
    setIsOpen(true);
    const id = (data && data.plmId) || "";
    //console.log(id);

    getpackagingLabelingMarking(
      {
        url: `/api/packagingLabelingMarking/?plmId=${id}`,
      },
      (res) => {
        //console.log(res);
        setProductDetails(res.productDetail);
      }
    );
  };

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedApprovalData(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";

    setLoading((prevState) => ({ ...prevState, [status]: true }));

    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        itemId: selectedApprovalData && selectedApprovalData.plmId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    updateApprovalStatus(
      {
        url: "/api/approvePackagingLabeling/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        FillDetail();
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Packaging and Labeling
            </label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Packaging/Labeling
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Doc No</th>
                          <th>Lot id</th>
                          <th>Packhouse Employee</th>
                          <th>Product Name</th>
                          <th>Quantity</th>
                          <th>Approval</th>
                          <th>QR Code</th>
                          {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.plmDate}</td>
                                <td>{itm.plmNo}</td>
                                <td>{itm.lotNo}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.packagingProductName}</td>
                                <td>
                                  {itm.totalInputQuantity +
                                    " " +
                                    itm.unitAbbreviation}
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(itm)}
                                    disabled={
                                      itm.nextlevel == 1
                                        ? itm.allowApproveUserId == loginUserId
                                          ? false
                                          : true
                                        : itm.approved == 0 &&
                                          itm.reportingId == loginUserId
                                        ? false
                                        : true
                                    }
                                  >
                                    {itm.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : itm.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(itm)}
                                  >
                                    <i className="fas fa-qrcode"></i>
                                  </button>
                                </td>
                                {canView === "block" && (
                                  <td>
                                    <button
                                      type="button"
                                      onClick={() => viewOpen(itm)}
                                      className="btn"
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="">
          <h3 className="card-title">Qr Codes</h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
        </div>

        <div className="qr-code-container">
          {boxQRData &&
            boxQRData.map((box, index) => (
              <>
                <div className="qr-con" key={index}>
                  <div className="row">
                    <div className="col pro-info">
                      <h5>{box.productName}</h5>
                    </div>
                    <div className="col packaging-info">
                      <p>Packing Date: 12/08/2023</p>
                      <p>Best Before: 19/08/2023</p>
                      <p>Net Weight: {box.netWeightPerCarton}</p>
                      <p>Gross Weight: {box.grossWeightPerCarton}</p>
                      <p>Price per Unit:{selectedData.pricePerUnit}</p>
                      <p>Packed item id:123 {selectedData.packedItemId}</p>
                    </div>
                    <div className="col qr-code">
                      <div key={index} className="qr-code-item">
                        <QRCode
                          id={`qr-code-canvas-${box.srNo}`}
                          value={JSON.stringify(box)}
                          size={90}
                          fgColor="#000000"
                          bgColor="#ffffff"
                          level="L"
                          renderAs="canvas"
                        />
                        <p>Box {box.srNo}</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <h6>Powered By FarmMobi</h6>
                    </div>
                    <div className="col">
                      <h6>Wash Before use</h6>
                    </div>
                    <div className="col">
                      <h6>Produce of India</h6>
                    </div>
                  </div>
                </div>
                <div className="download-button">
                  <button
                    className="btn btn-sm"
                    onClick={() => downloadQRCodeAtIndex(index)}
                  >
                    <i className="fas fa-download"> </i>
                  </button>
                </div>
              </>
            ))}
        </div>
      </Modal>

      {/* view modal */}
      <Modal isOpen={isOpen} style={customModalStyles2}>
        {selected && (
          <div className="mx-3">
            <div className="">
              <h3 className="card-title">Packaging Labeling Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setIsOpen(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>

            <div className="row">
              <p className="col-md-6">
                Packaging Labeling Date: {selected.plmDate}
              </p>
              <p className="col-md-6">
                Packhouse Employee: {selected.employeeName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Doc No: {selected.plmNo}</p>

              <p className="col-md-6">Lot Id: {selected.lotNo}</p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Product Name: {selected.packagingProductName}
              </p>
              <p className="col-md-6">
                Total input Quantity(No): {selected.totalInputQuantity}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Gross Weight PerCarton: {selected.grossWeightPerCarton}
              </p>
              <p className="col-md-6">
                Net Weight PerCarton: {selected.netWeightPerCarton}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Price Per Unit: {selected.pricePerUnit}
              </p>
              <p className="col-md-6">Unit: {selected.unitAbbreviation}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Shelf Life Days: {selected.shelfLifeDays}
              </p>
              <p className="col-md-6">Netting Count: {selected.nettingCount}</p>
            </div>

            <h5 className="card-title">Product Details</h5>
            <div className="text-center">
              <table className="table table-bordered table-sm">
                <thead>
                  <tr className="">
                    <th>Sr.No.</th>
                    <th>Product Name</th>
                    <th>Item Id</th>
                    <th>Product Sub Type</th>
                    <th>Product Type</th>
                    <th>Item Quantity</th>
                    <th>Unit</th>
                  </tr>
                </thead>
                <tbody>
                  {productDetails &&
                    productDetails.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{itm.productName}</td>
                          <td>{itm.itemId}</td>
                          <td>{itm.productSubTypeName}</td>
                          <td>{itm.productTypeName}</td>
                          <td>{itm.itemQuantity}</td>
                          <td>{itm.unitAbbreviation}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>
      <AntModal
        title="Packaging and Labelling Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("approve");
            }}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => {
              handleApprovalSubmit("disapprove");
            }}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("sendNextApprove");
            }}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default PackagingLabelingListview;
